import http from "./httpService";
import configData from ".././config.json";

var apiUrl = configData.apiUrl;
var mailapiUrl = configData.mailapiUrl;
// { apiUrl,mailapiUrl }
//to check registered user or not
export const CheckUser=(data)=>{
    const apiEndPoint = `${apiUrl}/CM_UserLogin`;
    return http.post(`${apiEndPoint}`,data); 
  }
  export const sendOtp=(data)=>{
    const apiEndPoint = `${apiUrl}/CM_SendSMSMsg`;
    return http.post(`${apiEndPoint}`,data); 
  }
//   CM_UserReg
export const RegeisterUser=(data)=>{
    const apiEndPoint = `${apiUrl}/CM_UserReg`;
    return http.post(`${apiEndPoint}`,data); 
  }


  //send otp in mail
export const sendMailOtp=(data)=>{
  const apiEndPoint = `${mailapiUrl}/verifyOTP`;
  return http.post(`${apiEndPoint}`,data); 
}
